import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';

import { AuthService } from './auth.service';
//import { ToastService } from '@app/core/toast/toast.service';

//import { Logger } from '@app/core';
//const log = new Logger('auth-guard.service');

@Injectable()
export class AuthGuard  {
  constructor(private authService: AuthService) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
    return this.authService.canActivateProtectedRoutes$.pipe(
      tap((canActivateProtectedRoutes: boolean) => {
        if (!canActivateProtectedRoutes) {
          this.authService.login();
        }
      })
    );
  }
}
